export default __webpack_public_path__ + "static/media/E_Contract.101ed38a.jpg";